import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormsService } from './forms.service';
import { MatSnackBar } from "@angular/material/snack-bar";

import { FormsGlobals} from '../../models/forms/forms.enum';
import { MessagingService } from '../../services/messaging.service';
import {PatientCaseWorkItemFormDataModel} from '../../models/forms/data/patient-case-work-item-form-data.model';
import {FormVersionConfigurationModel} from '../../models/forms/form-version-configuration.model';
import {FormConfigurationModel} from '../../models/forms/form-configuration.model';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.css']
})
export class FormsComponent implements OnInit {


  constructor(
    private formsService: FormsService,
    public formsGlobals: FormsGlobals,
    private messagingService: MessagingService,
  ) { }

  ngOnInit() {

  }



}
